import { Config } from '@/config';
import { ensureGtag, trackGtmEvent } from '@/utils/gtag';

type TrackingParams = Record<string, string | number | boolean | undefined>;

interface TrackEventOptions {
  event: string;
  params?: TrackingParams;
  trackWith?: {
    facebook?: boolean;
    umami?: boolean;
    gtm?: boolean;
  };
}

const fbq = (window as any).fbq;
const umami = (window as any).umami;

export function useTracker() {
  function track({ event, params = {}, trackWith = { umami: true } }: TrackEventOptions) {
    if (!Config.trackingEvents.enabled) return;
    trackWith.umami ??= true;
    trackWith.gtm ??= true;
    trackWith.facebook &&= typeof fbq !== 'undefined';
    trackWith.umami &&= typeof umami !== 'undefined';
    trackWith.gtm &&= typeof ensureGtag() === 'function';
    const sanitizedParams = Object.entries(params).reduce<Record<string, string | number | boolean>>(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = typeof value === 'string' ? value.trim() : value;
        }
        return acc;
      },
      {},
    );
    if (trackWith.facebook) fbq('track', event, sanitizedParams);
    if (trackWith.umami) umami.track(event, sanitizedParams);
    if (trackWith.gtm) trackGtmEvent(event, sanitizedParams);
  }
  return { track };
}
